import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const truncateFn = /* @__PURE__ */ createRecipe('Truncate', {
  "mode": "end"
}, [])

const truncateVariantMap = {
  "mode": [
    "middle",
    "end"
  ]
}

const truncateVariantKeys = Object.keys(truncateVariantMap)

export const truncate = /* @__PURE__ */ Object.assign(memo(truncateFn.recipeFn), {
  __recipe__: true,
  __name__: 'truncate',
  __getCompoundVariantCss__: truncateFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: truncateVariantKeys,
  variantMap: truncateVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, truncateVariantKeys)
  },
  getVariantProps: truncateFn.getVariantProps,
})